import {
  Button,
  Dialog,
  Grid,
  makeStyles,
  Typography,
} from '@quillbot/design-system';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import logger from 'core/logger/logger';
import Link from 'next/link';
import { login } from 'src/authentication/handlers/authentication';
import { RootState } from 'src/_common/models/redux/store';
import { setSignupModalState } from '@Common/actions/commonActions';
import Track from '@Common/handlers/track';
import Img from '@Common/components/img';

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.specialColors.BLUE_COLOR,
  },

  lowerContainer: {
    margin: '24px auto 60px',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    height: '100%',
    maxWidth: '325px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%',
    },
  },

  signUpTitle: {
    // maxWidth: '90%',
    fontSize: '26px',
    margin: '0px auto 32px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%',
    },
  },
  socialBtn: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
    height: '45px',
    width: '100%',
    textTransform: 'inherit',
    marginBottom: '8px !important',
    padding: '12px',
  },
  limitText: {
    padding: '8px 64px',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      padding: '8px 24px',
    },
  },
  boldText: {
    color: theme.palette.primary.main,
  },
  outerContainer: {
    padding: '5px 50px',
    [theme.breakpoints.down('sm')]: {
      padding: '0px 10px',
    },
  },
}));

export default function NewSignUpDialog() {
  const classes = useStyles();
  const showSignupModal = useSelector(
    (state: RootState) => state.common?.showSignUpModal
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (showSignupModal) Track.shownSignupModal();
  }, [showSignupModal]);

  const closeDialogBox = () => {
    dispatch(setSignupModalState(false));
  };

  const trackLinks = (method: 'signup' | 'login') => {
    Track.clickedSignupModalLinks(method);
  };

  const handleSocialButtons = (method: 'google' | 'facebook') => {
    Track.clickedSocialButtons(method);
    login(method)
      .then(() => closeDialogBox())
      .catch((e) => {
        logger('Modal Login Failed', e);
      });
  };

  return (
    <Dialog
      maxWidth="md"
      open={showSignupModal}
      aria-labelledby="max-width-dialog-title"
    >
      <Grid container className={classes.outerContainer}>
        <Grid className={classes.lowerContainer}>
          <Grid item xs={10} className={classes.signUpTitle}>
            Sign up to continue for <b className={classes.boldText}>FREE</b>
          </Grid>
          <Grid item xs={12} container>
            <Button
              classes={{
                root: classes.socialBtn,
              }}
              onClick={() => {
                handleSocialButtons('google');
              }}
              className="social-auth-btn"
            >
              <Img src="/emojis/solid_google.svg" alt="google logo" />
              <span>Continue with Google</span>
            </Button>
          </Grid>
          <Grid item xs={12} container>
            <Button
              onClick={() => {
                handleSocialButtons('facebook');
              }}
              classes={{
                root: classes.socialBtn,
              }}
              className="social-auth-btn"
            >
              <Img
                src="/emojis/solid_facebook.svg"
                style={{ left: '18.5px' }}
                alt="facebook logo"
              />
              <span>Continue with Facebook</span>
            </Button>
          </Grid>
          <Grid container>
            <Typography
              variant="body1"
              style={{
                fontSize: '11px',
                width: '100%',
                marginTop: '8px',
              }}
            >
              Or,{' '}
              <Link
                href={{
                  pathname: '/signup',
                  query: { referrer: 'paraphraserLimitSignupModal' },
                }}
              >
                <a
                  className={classes.link}
                  title="sign up"
                  onClick={() => {
                    closeDialogBox();
                    trackLinks('signup');
                  }}
                  role="button"
                  onKeyDown={() => {
                    closeDialogBox();
                    trackLinks('signup');
                  }}
                  tabIndex={0}
                >
                  sign up
                </a>
              </Link>{' '}
              or{' '}
              <Link
                href={{
                  pathname: '/login',
                  query: { referrer: 'paraphraserLimitSignupModal' },
                }}
              >
                <a
                  className={classes.link}
                  title="log in"
                  onClick={() => {
                    closeDialogBox();
                    trackLinks('login');
                  }}
                  role="button"
                  onKeyDown={() => {
                    closeDialogBox();
                    trackLinks('login');
                  }}
                  tabIndex={0}
                >
                  log in
                </a>
              </Link>{' '}
              with my email address.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
}
